import {t} from "@lingui/core/macro";
import {StyleSheet} from "aphrodite";

import Button from "@khanacademy/wonder-blocks-button";
import {View} from "@khanacademy/wonder-blocks-core";
import {spacing} from "@khanacademy/wonder-blocks-tokens";

import {CameraButton} from "../camera-capture/camera-button.tsx";

import arrowCounterClockwiseIcon from "@phosphor-icons/core/regular/arrow-counter-clockwise.svg";

interface Props {
    // Whether an image has been captured.
    hasImage: boolean;
    // The callback to retake the photo.
    onRetake: () => void;
    // The callback to capture a photo.
    onCapture: () => void;
    // Whether the capture button is disabled.
    captureDisabled: boolean;
}
/**
 * A component that displays the action buttons for the camera capture modal content.
 */
export const CameraCaptureActionButtons = ({
    hasImage,
    onRetake,
    onCapture,
    captureDisabled,
}: Props) => (
    <View style={styles.buttonRow}>
        {hasImage ? (
            <Button
                kind="tertiary"
                startIcon={arrowCounterClockwiseIcon}
                onClick={onRetake}
                aria-label={t`Retake photo`}
            >
                {t`Retake`}
            </Button>
        ) : (
            <CameraButton disabled={captureDisabled} onClick={onCapture} />
        )}
    </View>
);

const styles = StyleSheet.create({
    buttonRow: {
        alignItems: "center",
        justifyContent: "center",
        marginBlockStart: spacing.small_12,
    },
});
